import { MainHeader } from "../../components/main-header/MainHeader.jsx";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { RouterPaths } from "../../app/appConstants.js";
import ProfileButton from "../Account/components/ProfileButton/ProfileButton.jsx";
import React from "react";
import { PartnerWrapper } from "./styled/PartnerStyled.js";
import PartnerSupport from "./PartnerSupport.jsx";
import { LoginStyled } from "../Login/components/styled/LoginStyled.js";
import { useSetBodyBackgroundColor } from "../../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks.js";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

function PartnerPublicDocs() {
    const {getLangPath} = useLangContext();
    useSetBodyBackgroundColor('var(--app-bg-modal-color)', true);
    return <>
        <MainHeader>
            <Button variant="outline-primary" size="sm" as={Link} to={RouterPaths.trade}>
                {getLangPath('verify.trade')}
            </Button>
            <ProfileButton className="ms-2 ms-sm-3"/>
        </MainHeader>
        <PartnerWrapper>
            <LoginStyled>
                <PartnerSupport/>
            </LoginStyled>
        </PartnerWrapper>
    </>
}

export default PartnerPublicDocs;
